import { CampusIntro, CampusThemeContext } from 'atlas-ds';
import Head from 'next/head';
import { useContext } from 'react';

export default function Intro() {
    const metaDescription = "L'offre de formations sélectionnées par Atlas pour ses entreprises. Choisissez le parcours adapté à votre besoin."

    const theme = useContext(CampusThemeContext);

    return (
        <>
            <Head>
                <title key="__title">campusAtlas</title>
                <meta property="og:title" content="campusAtlas" key="__og:title" />
                <meta name="description" content={ metaDescription } key="__description" />
                <meta property="og:description" content={ metaDescription } key="__og:description" />
            </Head>

            { theme === "cap"
                ? <CampusIntro
                    title={<>Bienvenue sur cap compétence par <em>campusAtlas</em>,</>}
                    subtitle={<>l'offre de formations sélectionnée<br/>pour les agents généraux d'assurance.</>}
                    keyPoints={[
                        {
                            label: <><strong>125 modules</strong> de formation disponibles</>,
                            iconName: "graphique",
                        },
                        {
                            label: <>Des programmes <strong>DDA compatibles</strong></>,
                            iconName: "dda",
                        },
                        {
                            label: <>Des formations proposées sur <strong>tout le territoire</strong></>,
                            iconName: "carte-grande",
                        },
                        {
                            label: <>Besoin d'un conseil&nbsp;? Contactez les chargés de clientèle au <strong><a href="tel:+33175254140">01&nbsp;75&nbsp;25&nbsp;41&nbsp;40</a></strong></>,
                            iconName: "telephone",
                        }
                    ]}
                />
                : <CampusIntro
                    title={<>Bienvenue sur <em>campusAtlas</em>,</>}
                    subtitle={<>l'offre de formations sélectionnée<br/>par Atlas pour ses entreprises.</>}
                    keyPoints={[
                        {
                            label: <><strong>334 modules</strong> de formation conçus avec vos branches professionnelles</>,
                            iconName: "graphique",
                        },
                        {
                            label: <><strong>84 organismes</strong> de formation partenaires</>,
                            iconName: "batiment-grand",
                        },
                        {
                            label: <>Qualité garantie&nbsp;: <strong>91&nbsp;% de satisfaction</strong> en 2025</>,
                            iconName: "pouce",
                        },
                        {
                            label: <>Des <strong>tarifs négociés</strong> et un financement adapté</>,
                            iconName: "piece",
                        }
                    ]}
                />
            }
        </>
    )
}
